import type { OnboardingStep } from '../types'

/** Individual / mobile-consumer onboarding — no team size or invite steps. */
export const mobileConsumerSteps: OnboardingStep[] = [
    {
        id: 'use-case',
        question: 'What are you here to work on first?',
        subtitle: 'Pick what fits — you can change this anytime',
        type: 'single-select',
        options: [
            { id: 'personal-visibility', label: 'Build my personal visibility profile' },
            { id: 'foundation-interview', label: 'Complete a foundation interview' },
            { id: 'messaging-copy', label: 'Draft bios, intros, and posts' },
            { id: 'exploring', label: 'Just exploring for now' },
        ],
    },
    {
        id: 'business-industry',
        question: 'What best describes you?',
        type: 'single-select',
        hasOtherOption: true,
        options: [
            { id: 'personal-use', label: 'Individual / personal brand' },
            { id: 'consulting', label: 'Consulting / independent' },
            { id: 'technology', label: 'Technology / SaaS' },
            { id: 'marketing', label: 'Marketing / communications' },
            { id: 'finance', label: 'Finance' },
            { id: 'healthcare', label: 'Healthcare' },
            { id: 'influencer', label: 'Creator / influencer' },
            { id: 'non-profit', label: 'Non-profit' },
            { id: 'other-specify', label: 'Other (please specify)' },
        ],
    },
    {
        id: 'tone-style',
        question: 'What tone fits your voice best?',
        subtitle: 'Optional — helps Studio and deliverables',
        type: 'single-select',
        hasOtherOption: true,
        options: [
            { id: 'professional', label: 'Professional' },
            { id: 'casual', label: 'Casual' },
            { id: 'playful-professional', label: 'Warm but credible' },
            { id: 'inspirational', label: 'Inspirational' },
            { id: 'direct', label: 'Direct and concise' },
            { id: 'not-sure-yet', label: 'Not sure yet' },
        ],
    },
    {
        id: 'workspace-name',
        question: 'Name your workspace',
        subtitle: 'Your name or personal brand — this is just for you',
        type: 'text',
        inputPlaceholder: 'e.g., Matt B, My visibility profile',
        options: [],
        primaryActionLabel: 'Finish',
    },
]
